import { combineReducers } from "redux";

import { addonsSubCategoryDetails } from "./reducer.addonSubCategory"
const addonsSubCategoryReducers = combineReducers({

    addonsSubCategoryDetails

})
export default addonsSubCategoryReducers;
